// src/theme/state/tenantAtom.js
import { atom } from 'recoil';

/**
 * Global Recoil state containing the active tenant's white-label configuration.
 * When this updates, the ThemeProvider automatically regenerates the MUI theme
 * and the DOM listener updates the favicon and tab titles.
 */
export const tenantAtom = atom({
  key: 'tenantAtom',
  default: {
    organisation_name: 'Machadalo',
    logo_url: null,
    favicon_url: null,
    theme_config: {
      primary_color: '#4962e5', // Default Machadalo blue
      chat_primary_color: '#008d4d',
      secondary_color: '#7c3aed',
      background_color: '#f8fafc',
    },
  },
});
